<script lang="ts" module>
  import LoadingArea from '@/ui/base/LoadingArea.svelte';

  namespace NumberPill {
    export interface Props {
      value: number;
      loading?: boolean;
    }
  }
</script>

<script lang="ts">
  let { loading, value }: NumberPill.Props = $props();
</script>

<div
  class="flex size-8 items-center justify-center rounded-sm bg-info p-1 font-sans text-md font-semibold text-c-base"
>
  {#if loading}
    <LoadingArea />
  {:else}
    {value}
  {/if}
</div>
